'use client';

import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from 'next-themes';
import * as React from 'react';

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  // Always set defaultTheme to 'system' so 'default' in ThemeToggle means system theme
  return (
    <NextThemesProvider defaultTheme="system" {...props}>
      {children}
    </NextThemesProvider>
  );
}
